import { render, staticRenderFns } from "./QuestionFinish.vue?vue&type=template&id=16d09aba&"
import script from "./QuestionFinish.vue?vue&type=script&lang=js&"
export * from "./QuestionFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports